import { createSelector } from '@reduxjs/toolkit';
import { DropdownItemProps } from 'semantic-ui-react';

import { InsightsState } from 'app-redux/InsightsState';
import { orderBy } from 'lodash';

export const isAdminLoadingSelector = (state: InsightsState) => state?.admin?.isLoading;
export const usersSelector = (state: InsightsState) => state?.admin?.users;
export const emailTypesSelector = (state: InsightsState) => state?.admin?.emailTypes;
export const diseaseGroupsSelector = (state: InsightsState) => state?.admin?.customDiseaseGroups;
export const customDiseaseRelevanceSelector = (state: InsightsState) => state?.admin?.customDiseaseRelevance;

export const usersAsDropdownItems = createSelector(usersSelector, users =>
  users.map(({ id, userName }) => ({ key: id, value: id, text: userName } as DropdownItemProps))
);
export const usersAlphabetical = createSelector(usersSelector, users => orderBy(users, user => user.userName));
